import {useIdeationScope} from '../../../context/IdeationScope'
import styles from './IdeationInsights.module.scss'
import {ideationApi} from '../../../../../api/ideationApi'
import {IdeationSummary} from './IdeationSummary/IdeationSummary'
import {IdeationActions} from './IdeationActions/IdeationActions'
import {IdeationTrends} from './IdeationTrends/IdeationTrends'
import {IdeationSentiments} from './IdeationSentiments/IdeationSentiments'
import {LoadingPage} from '../../../../LoadingPage'
import {IdeationEmotions} from './IdeationEmotions/IdeationEmotions'
export const IdeationInsights: React.FC = () => {
  const {ideationId} = useIdeationScope()
  const {data: ideation} = ideationApi.useIdeation(ideationId)
  const {data: insights, isLoading: insightsLoading} =
    ideationApi.useIdeationInsights(ideationId)

  return (
    <div className={styles.ideaFlowInsights}>
      <div className={styles.ideaFlowInsightsHeader}>
        <p className={styles.ideaFlowInsightsHeaderIntroduction}>
          {ideation?.introduction}
        </p>
        <p className={'idea-flow-insights--header--question'}>
          {ideation?.allowIdeas && ideation?.questions?.[0]?.question}
        </p>
      </div>
      {!insightsLoading && insights ? (
        <div className={styles.ideaFlowInsightsPage}>
          <IdeationSummary />
          <div className={styles.ideaFlowInsightsSection}>
            <IdeationEmotions />
            <IdeationSentiments />
          </div>
          <IdeationTrends />
          <IdeationActions />
        </div>
      ) : (
        <div className="initiative-sidebar--relative-section">
          <LoadingPage />
        </div>
      )}
    </div>
  )
}
